import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../../../hooks/customDocumentTitleHook";
import { useLocation } from "react-router-dom";
import { getPractice, getSecureData, location_name } from "../../../../helpers";

export default function CommunityAssessmentPrint() {
  const [formData, setFormData] = useState(null);
  const [printFilter, setPrintFilter] = useState(null);
  const contentRef = useRef();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const formSize = queryParams.get('size');
  const website = getPractice("website");

  useEffect(() => {
    const fetchStoredData = async () => {
      const storedData = await getSecureData("communityPrintData");
      if (storedData) {
        setFormData(storedData.results);
        setPrintFilter(storedData.filter);
      }
    };

    fetchStoredData();
  }, []);


  const handlePrint = () => {
    window.print();
  };

  const handleCloseWindow = () => {
    window.close();
  };

  useEffect(() => {
    const pageSize = formSize == "A4" ? "A4" : "Letter";
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media print {
        @page {
          size: ${pageSize};
        }
      }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [formSize]);

  const firstTableData = formData?.slice(0, 17);
  const secondTableData = formData?.slice(17);

  useDocumentTitle("Community Assessment Form");

  return (
    <div ref={contentRef} className="docpro_signout_wrap">
      <div className="docpro_signout">
        <div style={{ width: '55%', marginLeft: 'auto' }}>
          <p className="text-start" style={{ marginBottom: '8px' }}><b>Location: </b> {location_name(printFilter?.location_id)}</p>
          <p className="text-start" style={{ marginBottom: '8px' }}>
            <b>Duration: </b> 
            {printFilter?.from_dos}
            {printFilter?.to_dos && printFilter?.from_dos !== printFilter?.to_dos && ` - ${printFilter.to_dos}`}
          </p>

          <p style={{ letterSpacing: '3px' }}>{website}</p>
        </div>

        <div style={{ margin: '2rem 0 1rem' }}>
          <h5 className="mb-0" style={{ textTransform: 'uppercase' }}>
            COMMUNITY RESOURCE NEED ASSESSMENT - 
          </h5>
        </div>

        <div className="docpro_table_1 hipaa_table" style={{ boxShadow: 'none', borderRadius: 0 }}>
          <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '10%', fontSize: 'medium', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                <th style={{ width: '70%', fontSize: 'medium', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                <th className="text-center" style={{ width: '10%', fontSize: 'medium', borderRight: '1px solid var(--border)' }}>Yes</th>
                <th className="text-center" style={{ width: '10%', fontSize: 'medium' }}>No</th>
              </tr>
            </thead>
            <tbody>
              {firstTableData?.map((item, index) => (
                <tr key={index}>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>{index+1}</td>
                  <td style={{ width: '70%', borderRight: '1px solid var(--border)' }}>{item?.question}</td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>{item?.yes}</td>
                  <td className="text-center">{item?.no}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {formSize == 'A4' ?
          <div className="spacing_14 mt-2"></div>
        :
          <div className="spacing_3 mt-1"></div>
        }
        <div className="page_divider"></div>

        <div className="docpro_table_1 hipaa_table" style={{ boxShadow: 'none', borderRadius: 0 }}>
          <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '10%', fontSize: 'medium', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                <th style={{ width: '70%', fontSize: 'medium', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                <th className="text-center" style={{ width: '10%', fontSize: 'medium', borderRight: '1px solid var(--border)' }}>Yes</th>
                <th className="text-center" style={{ width: '10%', fontSize: 'medium' }}>No</th>
              </tr>
            </thead>
            <tbody>
              {secondTableData?.map((item, index) => (
                <tr key={index}>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>{index+18}</td>
                  <td style={{ width: '70%', borderRight: '1px solid var(--border)' }}>{item?.question}</td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>{item?.yes}</td>
                  <td className="text-center">{item?.no}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="docpro_invoice_btns docpro_hide_print">
        <button
          className="docpro_invoice_btn docpro_color3 close_button"
          onClick={handleCloseWindow}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </span>
          <span className="docpro_btn_text">Close</span>
        </button>

        <button
          className="docpro_invoice_btn docpro_color1"
          onClick={handlePrint}
        >
          <span className="docpro_btn_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ionicon"
              viewBox="0 0 512 512"
            >
              <path
                d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H100a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24"
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth={32}
              />
              <rect
                x={128}
                y={240}
                width={256}
                height={208}
                rx="24.32"
                ry="24.32"
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth={32}
              />
              <path
                d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24"
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth={32}
              />
              <circle cx={392} cy={184} r={24} fill="currentColor" />
            </svg>
          </span>
          <span className="docpro_btn_text">Print</span>
        </button>
      </div>
    </div>
  );
}
